module.exports = __webpack_public_path__ + "static/img/Sam-Flanders.a718885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Flanders.jpg
// module id = iqcs
// module chunks = 0